import { makeAutoObservable } from 'mobx';
import { appManagerService, IGetFormListConfigReq, IGetFormListConfigRsp } from '@/service/app-manager';

type CacheEntry<T> = {
  expiresAt: number;
  promise: Promise<T>;
};

const DEFAULT_TTL_MS = 5 * 60 * 1000;
const formListConfigCache = new Map<string, CacheEntry<IGetFormListConfigRsp>>();

export class FormListConfigStore {
  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }


  /**
   * 全局缓存：同 monitorKey（或同 req）在 TTL 内复用结果，并合并并发请求，避免重复触发接口。
   * - 命中缓存：直接返回同一个 Promise（可去重并发）
   * - 失败：自动清理缓存，允许下次重试
   */
  public getFormListConfig(
    req: IGetFormListConfigReq,
    options?: { ttlMs?: number },
  ): Promise<IGetFormListConfigRsp> {
    const ttlMs = options?.ttlMs ?? DEFAULT_TTL_MS;
    const now = Date.now();
    const key = this.buildCacheKey(req);

    const existing = formListConfigCache.get(key);
    if (existing && existing.expiresAt > now) {
      return existing.promise;
    }

    const promise = appManagerService.getFormListConfig(req).catch((err) => {
      const current = formListConfigCache.get(key);
      if (current?.promise === promise) {
        formListConfigCache.delete(key);
      }
      throw err;
    });

    formListConfigCache.set(key, { expiresAt: now + ttlMs, promise });
    return promise;
  }

  public clearFormListConfigCache(req?: IGetFormListConfigReq) {
    if (!req) {
      formListConfigCache.clear();
      return;
    }
    formListConfigCache.delete(this.buildCacheKey(req));
  }
  private buildCacheKey(req: IGetFormListConfigReq): string {
    const monitorKey = (req as any)?.monitorKey as string | undefined;
    if (monitorKey) {
      return `monitorKey:${monitorKey}`;
    }
    return `req:${JSON.stringify(req)}`;
  }
}


